import React from 'react';
import { Table as AntTable, Space, Avatar, Input ,Button } from 'antd';
import { useState,useRef } from "react";
import { UserOutlined,SearchOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import { USER_ROLE_MAPPING } from '../../../../data/constant';
import { AccountSecurityCell } from '../../../../components';

const headerStyle = {
  color: '#525252',
};

const Table = ({ data, onEdit, loading, onRefresh }) => {
  const [ setSearchText] = useState('');
  const [ setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    { 
      title: 'ลำดับ',
      align: 'center',  
      width: 60, 
      dataIndex: 'number',
      key: 'number',
      onHeaderCell: () =>{return {style:headerStyle}}
    },
    { 
      title: 'UserName', 
      align: 'center', 
      dataIndex: 'UserName', 
      key: 'UserName',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      ...getColumnSearchProps('UserName'),
    },
    { 
      title: 'Role', 
      align: 'center', 
      dataIndex: 'userRole', 
      key: 'userRole',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      render: (userRole) => USER_ROLE_MAPPING[userRole] || '-'
    },
    {
      title: 'Company',
      align: 'center',
      dataIndex: 'companyName',
      key: 'companyName',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      render: (companyName) => companyName || '-'
    },
    {
      title: 'รหัสผ่าน / 2FA',
      key: 'security',
      align: 'center',
      width: 320,
      render: (record) => (
        <AccountSecurityCell record={record} apiBase="/api/v1/usersbackoffice" onDone={onRefresh} />
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: 'การจัดการ',
      fixed: 'right',
      key: 'actions',
      align: 'center',
      render: (record) => (
        <Space size="middle">
          <div className="text-blue-500 cursor-pointer" onClick={() => onEdit(record)}>
            แก้ไข
          </div>
        </Space>
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    }
  ];

  return ( 
    <div className='overflow-x-auto'>
      <AntTable 
        loading={loading}   
        className='border-1 rounded-lg border-gray-200' 
        dataSource={genNumberTable(data)}
        columns={columns}  
        pagination={{ pageSize: 8 }} 
        rowKey={'id'}
        scroll={{ x: 'max-content' }}  
      />
    </div>
  );
};

export default Table;
